<template>
  <div>
    <div class="flex justify-between items-center">
      <label class="flex items-center h-5">
        <input
          v-bind="$attrs"
          v-model="$attrs.modelValue"
          class="form-checkbox"
          type="checkbox"
        >
        <span class="ml-3 text-sm leading-5">
          {{ label }}
        </span>
      </label>
      <button v-if="$slots.default" @click="state.show = !state.show" class="ml-2" :aria-label="state.show ? '`Weniger zu ${label}`' : `Mehr zu ${label}`">
        <Icon :type="state.show ? 'remove' : 'add'" />
      </button>
    </div>
    <div
      v-if="$slots.default && state.show"
      class="text text-xs wrap mt-2 p-4 bg-gray-100 rounded"
    >
      <slot name="default"></slot>
    </div>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import Icon from './Icon.vue';

defineProps({
  label: {
    type: String,
    required: true,
  }
});

const state = reactive({
  show: false,
});

</script>
